import AssignmentsService from "../../services/api/Assignments/AssignmentsService";

const namespace = "ASSIGNMENTS";
export const GET_ASSIGNMENTS_SUCCESS = `${namespace}/GET_ASSIGNMENTS_SUCCESS`;
export const GET_ASSIGNMENTS_FAIL = `${namespace}/GET_ASSIGNMENTS_FAIL`;
export const SET_SORTING_OPTIONS = `${namespace}/SET_SORTING_OPTIONS`;


export function getAllAssignments(sortOptions) {
    return function (dispatch) {
        return AssignmentsService.getAllAssignments(sortOptions)
            .then((result) => dispatch({type: GET_ASSIGNMENTS_SUCCESS, assignments: result.assignments, total: result.total}))
            .catch((err) => dispatch({type: GET_ASSIGNMENTS_FAIL, err: JSON.stringify(err.stack)}));
    };
}

export function setAssignmentSortingOptions(sortOptions){
    return(dispatch) => {
        dispatch({type: SET_SORTING_OPTIONS, sortOptions});
    };
}